import styled from '@emotion/styled'
import {keyframes} from '@emotion/react'
import {theme} from '../../theme'
import {StyledInfoIcon} from '../../shared/icons/icons.styles'

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0); }
`

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  // align-items: center;
  gap: ${theme.space[5]};
  // width: 100%;
  width: fit-content;
  // border: 1px solid ${theme.colors.input.focusRing};
  // padding: 10px 20px;
  border-radius: 20px;
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  // align-items: center;
  gap: ${theme.space[2]};
`

export const Title = styled.h3`
  font-size: ${theme.fontSizes.base};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.primary};
  margin: 0;
`

export const Subtitle = styled.p`
  font-size: ${theme.fontSizes.xs};
  font-weight: ${theme.fontWeights.regular};
  color: ${theme.colors.text.primary};
  margin: 0;
`

export const InputRowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  // align-items: center;
  gap: ${theme.space[2]};
  width: 500px;
`
export const InputRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${theme.space[3]};
  width: 100%;
`

export const InputFill = styled.div`
  flex: 1;
`

export const SearchButtonWrapper = styled.div`
  flex-shrink: 0;
`

export const StatusLine = styled.p`
  display: inline-flex;
  gap: ${theme.space[2]};
  align-items: center;
  justify-content: flex-start;
  font-size: ${theme.fontSizes.sm};
  margin: 0;
  animation: ${fadeIn} 0.2s ease;
  font-weight: ${theme.fontWeights.medium};

  color: ${({variant}) => {
    if (variant === 'not-found') return theme.colors.text.primary
    if (variant === 'found') return theme.colors.text.brandBlue
    if (variant === 'multiple-accounts') return theme.colors.text.brandBlue
    // if (variant === 'not-found') return theme.colors.status.success.text
    // if (variant === 'found') return theme.colors.status.success.text
    if (variant === 'error') return theme.colors.status.danger.text
    return theme.colors.text.primary
  }};

  strong {
    font-weight: ${theme.fontWeights.bold};
  }
`

// info.svg's paths carry a hardcoded fill, so color: inherit on the wrapper
// alone won't recolor it — force the paths to pick up StatusLine's color.
export const StatusIcon = styled(StyledInfoIcon)`
  path {
    fill: currentColor;
  }
`

export const InfoIcon = styled.div`
  font-size: ${theme.fontSizes.sm};
  width: 12px;
  height: 12px;
`
export const FooterRow = styled.div`
  display: flex;
  gap: ${theme.space[3]};
  width: 100%;
  justify-content: center;

  & > * {
    flex: 1;
  }
`
export const FooterCenter = styled.div`
  display: flex;
  justify-content: center;
  gap: ${theme.space[3]};
  margin-top: 12px;
`
